// extracted by mini-css-extract-plugin
export default {"secblackmain":"secblac_secblackmain__kWH1b","secblactext":"secblac_secblactext__n5YDS","secblackbut":"secblac_secblackbut__a1Ot4"};